module.exports = __webpack_public_path__ + "31c0e998cc5d3559db5757c75df61caa.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_1_sq.mp3
 ** module id = 168
 ** module chunks = 0
 **/